"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfirmDeleteAddressDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const ConfirmDeleteAddressDialog = ({
  isDialogOpen,
  onClose,
  onConfirmDelete
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const header = formatMessage('deleteAddress');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
    hideCloseButton: true,
    severity: "error",
    open: isDialogOpen,
    header: header,
    maxWidth: "700px",
    actions: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      color: "error",
      variant: "contained",
      onClick: onConfirmDelete,
      ...getTestIdProps(_models.TestId.DeleteButton),
      children: formatMessage('deleteAddress')
    }, "delete"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      component: "button",
      variant: "button",
      onClick: onClose,
      ...getTestIdProps(_models.TestId.CancelButton),
      children: formatMessage('cancel')
    }, "cancel")],
    onClose: onClose,
    ...getTestIdProps(_models.TestId.ConfirmDeleteAddressModal),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: formatMessage('areYouSureYouWantToDeleteThisAddress')
    })
  });
};
exports.ConfirmDeleteAddressDialog = ConfirmDeleteAddressDialog;
var _default = exports.default = ConfirmDeleteAddressDialog;